var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon24PxTrendFireOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9849 2.87795C10.8995 2.82697 10.802 2.80005 10.7025 2.80005C10.6031 2.80005 10.5056 2.82697 10.4202 2.87795C10.3498 2.93373 10.3023 3.01338 10.2867 3.10183C10.2711 3.19028 10.2885 3.28138 10.3355 3.35789C12.0718 6.36455 12.4388 10.4581 10.0673 12.7167C9.15492 11.9499 8.43055 10.9841 7.94996 9.89352C7.07299 10.3806 6.3462 11.0986 5.84849 11.9696C5.35079 12.8405 5.10119 13.8312 5.12679 14.834C5.1626 15.7181 5.37486 16.586 5.7511 17.3869C6.12734 18.1877 6.65995 18.905 7.31759 19.4969C7.97524 20.0888 8.74463 20.5432 9.58048 20.8333C10.4164 21.1233 11.3018 21.2434 12.1847 21.1862C16.73 21.1862 19.0873 18.3631 19.2426 14.834C19.4262 10.5993 16.4195 5.39057 10.9849 2.87795Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24PxTrendFireOutline);
export default __webpack_public_path__ + "static/media/icon_24px_trend-fire_outline.5759f7a34241ad1cc2eafc24639cb65b.svg";
export { ForwardRef as ReactComponent };